export default {
  loginFailed: "登录失败，请再尝试。",
  requestFailed: "请求失败，请检查您的互联网连接。",
  invalidLogin: "无效的用户名或密码。",
  invalidPassword: "无效的用户名或密码。",
  thisFunctionExists: "此功能已存在。",
  thisFunctionNotAllowDelete: "此功能不允许删除。",
  thisFunctionNotExists: "此功能不存在。",
  targetFunctionIdRequired: "目标功能ID不能为空。",
  thisPageExists: "此页面已存在。",
  thisPageNotAllowDelete: "此页面不允许删除。",
  thisRoleExists: "此角色已存在。",
  thisRoleExist: "此角色已存在",
  thisRoleNotAllowDelete: "此角色不允许删除。",
  targetRoleIdRequired: "目标角色ID不能为空",
  systemError: "系统无法处理您的请求。",
  actionbyRequired: "当前用户登录ID不能为空。",
  sessionTokenRequired: "Session Token 不能为空。",
  functionIdRequired: "功能ID不能为空。",
  functionNameRequired: "功能名称不能为空。",
  newFunctionNameRequired: "新功能名称不能为空。",
  pageIdRequired: "页面ID不能为空。",
  newPageIdRequired: "新页面不能为空 （添加页面）。",
  newPageNameRequired: "新页面名称不能为空 （添加页面/编辑页面）。",
  targetPageIdRequired: "页面ID （删除页面/获取页面角色列表/设置页面角色/编辑页面）。",
  userIdRequired: "用户ID不能为空。",
  passwordRequired: "密码不能为空。",
  userNameRequired: "用户名不能为空。",
  passwordValidation: "密码必须是6-20个字符以及数字和字母的组合。",
  pageNumRequired: "页码。",
  pageSizeRequired: "页面大小（行）。",
  roleIdRequired: "角色ID不能为空。",
  oldPasswordRequired: "当前密码不能为空。",
  userStatusRequired: "用户状态不能为空。",
  newRoleIdRequired: "新角色不能为空 （添加角色）。",
  newRoleNameRequired: "新角色名称不能为空 （添加角色/编辑角色）。",
  startDateRequired: "开始日期不能为空。",
  endDateRequired: "结束日期不能为空。",
  startDateIsGteEndDate: "开始日期大于结束日期。",
  sportsTypeRequired: "运动类型不能为空。",
  teamTypeRequired: "团队类型不能为空。",
  thisRoleNotExists: "此角色不存在。",
  thisPageNotExists: "此页面不存在。",
  thisUserExists: "此用户ID已存在。",
  thisUserNotExists: "此用户ID不存在。",
  thisUserBlackListed: "此用户已被列入黑名单。",
  thisUserInactive: "此用户冻结。",
  thisUserBlocked: "此用户已被阻塞。",
  thisUserNotActive: "此用户未激活。",
  invalidUser: "无效的用户。",
  NoUserAccessRight: "该用户无权访问此页面。",
  unableSPProcess: "系统无法处理您的请求。",
  connection: "连接错误",
  thisProviderExists: "此提供商已存在。",
  thisProviderNotExists: "此提供商不存在。",
  thisProviderNotAllowDelete: "此提供商不允许删除。",
  thisHostExists: "此主机已存在。",
  thisHostNotExists: "此主机不存在。",
  thisHostUrlExists: "此主机URL 已存在。",
  hostUrlRequired: "主机网址不能为空。",
  targetHostIdRequired: "目标主机ID 不能为空。",
  newProviderIdRequired: "新提供商ID 不能为空。",
  newHostUrlRequired: "新主机网址不能为空。",
  hostIdRequired: "主机ID 不能为空。",
  hostDisabledRequired: "禁用主机不能为空。",
  providerIdRequired: "提供商ID 不能为空。",
  providerNameRequired: "提供商名称不能为空。",
  targetProviderIdRequired: "目标提供商ID 不能为空。",
  newProviderNameRequired: "新提供商名称不能为空。",
  providerDisabledRequired: "禁用提供商不能为空。",
  loginIdRequired: "登录ID 不能为空。",
  loginNameRequired: "登录名不能为空。",
  targetLoginIdRequired: "目标登录ID 不能为空。",
  newHostIdRequired: "主机ID 不能为空。",
  newLoginNameRequired: "登录名不能为空。",
  loginDisabledRequired: "禁用登录不能为空。",
  thisLoginExists: "此登录已存在。",
  thisLoginNotExists: "此登录不存在。",
  
  isRequired: "请输入{fname}。",
  isMinValue: "{fname}必须至少为{fvalue}.",
  isMaxValue: "{fname}必须小于或等于{fvalue}.",
  isMinLength: "{fname}必须至少包含{fvalue}个字符。",
  isMaxLength: "{fname}必须小于或等于{fvalue}个字符。",
  isAlphaNum: "{fname}必须是字母数字。",
  isSameAs: "{fname}必须与{fname2}相同",
  isUrl: "{fname} 仅接受网址。",
  containAlphaNum: "{fname}必须至少有一个数字和一个字母。",
  selectOption: "请选择{fname}",
  notSameAs: "{fname}和{fname2}不能一样。",
  
};
